import { useMutation, useQueryClient, type DefaultError, type UseMutationOptions } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

type Params = Parameters<typeof apiClient.setCategoryGoals>[0];

export const useSetCategoryGoals = (options?: UseMutationOptions<void, DefaultError, Params>) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (params: Params) => {
      await apiClient.setCategoryGoals(params);
    },
    onSuccess: (...args) => {
      void queryClient.invalidateQueries({ queryKey: ["categoryGoals"] });
      options?.onSuccess?.(...args);
    },
    ...options,
  });
};
